<template>
  <v-dialog max-width="500" v-model="dialog">
    <template v-slot:activator="{ on }">
      <v-btn class="primary" dark v-on="on">{{ $t("NewTrip.newTrip") }}</v-btn>
    </template>

    <v-card max-height="80vh" class="mx-auto overflow-y-auto">
      <img class="white--text" width="500" height="200" :src="imageSrc || imageUrl" />

      <v-card-text style="position: relative">
        <input
          type="file"
          style="display: none"
          ref="image"
          accept="image/*"
          @change="onFilePicked"
        />
        <v-btn color="primary" dark absolute top right fab @click="$refs.image.click()">
          <v-icon>mdi-camera</v-icon>
        </v-btn>
      </v-card-text>

      <v-container class="px-4 mt-n4">
        <v-form ref="form">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="tripName"
                class="mx-3"
                :label="$t('NewTrip.tripName')"
                required
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="tripDescription"
                :label="$t('common.description')"
                rows="2"
                counter
                maxlength="120"
                class="mx-3"
              >
              </v-textarea>
            </v-col>
            <v-col v-if="promptAudioGuides" cols="12">
              <v-checkbox v-model="audioguides" label="Display audioguides"></v-checkbox>
            </v-col>
            <v-col cols="12" v-if="companies.length > 1">
              <v-select
                v-model="selectedCompanyId"
                class="mx-2"
                :items="companies"
                :label="$t('common.company')"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-col>
            <!-- <v-col cols="12">
            <v-select
              v-model="addOns"
              class="mx-2"
              :items="allAddOns"
              label="Add ons"
              item-text="name"
              item-value="id"
              multiple
            ></v-select>
            <v-btn small text color="primary" class="text-none text-decoration-underline"
              >About add ons</v-btn
            >
          </v-col> -->
            <!-- <v-col cols="12">
              <v-radio-group v-model="isVirtual" :rules="[rules.required2]">
                <template v-slot:label>
                  <div>{{ $t("NewTrip.type") }}</div>
                </template>
                <v-radio :value="true">
                  <template v-slot:label>
                    <div>{{ $t("NewTrip.virtual") }}</div>
                  </template>
                </v-radio>
                <v-radio :value="false">
                  <template v-slot:label>
                    <div>{{ $t("NewTrip.inDestination") }}</div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col> -->

            <v-col cols="12" sm="6">
              <v-menu
                v-model="menuStartDate"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="startDate | strToDate('P')"
                    :label="$t('common.startDate')"
                    :rules="[rules.required]"
                    prepend-icon="mdi-calendar-arrow-left"
                    readonly
                    persistent-hint
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="startDate" @input="menuStartDate = false"></v-date-picker>
              </v-menu>
            </v-col>
            <div class="flex-grow-1"></div>
            <v-col cols="12" sm="6">
              <v-menu
                v-model="menuEndDate"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="endDate | strToDate('P')"
                    :label="$t('common.endDate')"
                    prepend-icon="mdi-calendar-arrow-right"
                    readonly
                    persistent-hint
                    v-on="on"
                    :rules="[rules.required]"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="endDate" :min="startDate" @input="menuEndDate = false">
                </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" v-show="endDate != null">
              <h4 class="grey--text">{{ $t("NewTrip.visitingCities") }}</h4>
              <template v-for="index in cities.length">
                <div
                  :key="cities[index - 1].cityId"
                  style="
                    border: 1px solid #ccc !important;
                    border-style: solid;
                    border-radius: 16px;
                  "
                  class="mb-1 pa-2"
                >
                  <div class="d-flex flex-row align-center">
                    <CitiesAutocomplete @selected-city="cityAdded($event, index)" />
                    <div v-if="cities[index - 1].place_name">
                      <v-btn
                        icon
                        @click="
                          cities.splice(index - 1, 1);
                          menuDepartureDates.splice(index - 1, 1);
                        "
                      >
                        <v-icon> mdi-close</v-icon>
                      </v-btn>
                    </div>
                  </div>
                  <!-- <v-row v-if="cities[index - 1].place_name"> -->
                  <v-row>
                    <v-col cols="2" sm="6">
                      <v-menu
                        v-model="menuArrivalDates[index - 1]"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :value="cities[index - 1].arrival_date | strToDate('P')"
                            :label="$t('NewTrip.arrivalDate')"
                            prepend-icon="mdi-calendar-arrow-left"
                            readonly
                            persistent-hint
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="cities[index - 1].arrival_date"
                          :min="index === 1 ? startDate : cities[index - 2].departure_date"
                          :max="endDate"
                          @input="closeArrivalPicker(index - 1)"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <div class="flex-grow-1"></div>
                    <v-col cols="2" sm="6">
                      <v-menu
                        v-model="menuDepartureDates[index - 1]"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :value="cities[index - 1].departure_date | strToDate('P')"
                            :label="$t('NewTrip.departureDate')"
                            prepend-icon="mdi-calendar-arrow-right"
                            readonly
                            persistent-hint
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="cities[index - 1].departure_date"
                          :min="
                            index === 1
                              ? cities[index - 1].arrival_date != null
                                ? cities[index - 1].arrival_date
                                : startDate
                              : cities[index - 2].departure_date
                          "
                          :max="endDate"
                          @input="closeDeparturePicker(index - 1)"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </div>
              </template>
              <div class="d-flex flex-row-reverse mx-4">
                <v-btn v-show="canAddField" color="secondary" @click="addField"
                  >{{ $t("NewTrip.newCity") }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <!-- <p>Cost per traveler ${{ (10 + addOnsPrice).toFixed(2) }}</p> -->
          <p class="red--text body-2 text-center">{{ feedback }}</p>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :loading="saving" block class="primary" @click="saveData()">{{
              $t("common.create")
            }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-container>
    </v-card>
    <v-snackbar v-model="snackbar">
      {{ $t("common.tripSuccess") }}
      <v-btn color="primary" text @click="snackbar = false">{{ $t("common.close") }}</v-btn>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import { parseISO, endOfDay } from "date-fns";
import firestore from "@/firebase/firestore";
import functions from "@/firebase/functions";
import database from "@/firebase/database";
import storage from "@/firebase/storage";
import { uuid } from "vue-uuid";
import { zonedTimeToUtc } from "date-fns-tz";

import CitiesAutocomplete from "@/components/CurrentTrip/Cities/CitiesAutocomplete";
import mbApi from "@/APIS/mapbox-api";

function initialState() {
  return {
    tripName: null,
    isVirtual: false,
    tripDescription: null,
    startDate: new Date().toISOString().slice(0, 10),
    allAddOns: [
      { id: "weather", name: "City Weather", price: 0 },
      { id: "expenses", name: "Expense tracker", price: 0 },
      { id: "exchange", name: "Currency Exchange", price: 0 },
      // { id: "hdImages", name: "HD Feed Images", price: 1.5 },
      { id: "flights", name: "Realtime flight status", price: 0 },
      { id: "offline", name: "Offline Sync", price: 0 },
    ],
    addOns: [],
    menuStartDate: false,
    endDate: null,
    menuEndDate: false,

    rules: {
      required: (value) => !!value || "Required.",
      required2: (value) => value != null || "Required.",
    },
    arrivalDate: null,
    menuArrivalDate: false,
    menuDepartureDate: false,
    departureDate: null,

    arrivalDates: [],
    departureDates: [],
    menuArrivalDates: [false],
    menuDepartureDates: [false],

    feedback: null,
    dialog: false,

    cities: [{ cityId: 0 }],
    cityId: 0,
    canAddField: false,
    selectedCompanyId: null,

    imageSrc: null,
    file: null,
    saving: false,
    snackbar: false,
    audioguides: false,
  };
}

export default {
  name: "Settings",
  components: { CitiesAutocomplete },
  data() {
    return initialState();
  },
  methods: {
    cityAdded(city, index) {
      console.log("city added, ", index);
      this.cities[index - 1] = { ...this.cities[index - 1], ...city };
      this.canAddField = true;
    },
    addField() {
      this.canAddField = false;
      this.cityId += 1;
      this.cities.push({ cityId: this.cityId });
      this.menuArrivalDates.push(false);
      this.menuDepartureDates.push(false);
    },
    saveCity(tripId, cityPlacemark) {
      if (!cityPlacemark.properties || !cityPlacemark.properties.full_address) {
        return;
      }
      mbApi.createCity(cityPlacemark).then((city) => {
        console.log(city);
        firestore.writeCity(tripId, "cities", cityPlacemark.properties.name, city);
      });
    },
    closeArrivalPicker(index) {
      this.$set(this.menuArrivalDates, index, false);
    },
    closeDeparturePicker(index) {
      this.$set(this.menuDepartureDates, index, false);
    },
    saveData() {
      if (!this.$refs.form.validate()) {
        console.log("form not valid");

        if (!this.tripName) {
          this.feedback = this.$t("NewTrip.feedback1");
          return;
        }

        if (!this.startDate) {
          this.feedback = this.$t("NewTrip.feedback2");
          return;
        }

        if (!this.endDate) {
          this.feedback = this.$t("NewTrip.feedback3");
          return;
        }
        // if (this.isVirtual == null) {
        //   this.feedback = this.$t("NewTrip.feedbackNoType");
        //   return;
        // }
        return;
      }

      const startDate = zonedTimeToUtc(parseISO(this.startDate), "utc");
      const endDate = zonedTimeToUtc(endOfDay(parseISO(this.endDate)), "utc");
      if (startDate > endDate) {
        this.feedback = this.$t("NewTrip.feedback4");
        return;
      }
      const userId = this.$store.state.firUser.uid;
      let companyId = this.selectedCompanyId;
      if (this.companies.length > 1 && !companyId) {
        this.feedback = this.$t("NewTrip.feedback5");
        return;
      }
      if (!companyId) {
        companyId = this.companies[0].id;
      }

      console.log(`creating trip for companyId ${companyId}`);
      this.feedback = null;

      this.saving = true;

      const data = {
        name: this.tripName,
        user_ids: { [userId]: true },
        force_location: false,
        virtual: this.isVirtual,
        privacy: "public",
        start_date: startDate.getTime(),
        end_date: endDate.getTime(),
        chat_settings: 0, // todo, ask setting
        contact: this.$store.state.firUser.uid,
        activity_notifications: true,
        company: companyId,
        description: this.tripDescription || "",
      };

      if (this.promptAudioGuides) {
        data.audio_guides = this.audioguides;
      }

      const addons = {};
      this.allAddOns.forEach((addon) => {
        addons[addon.id] = true;
      });

      functions
        .createTrip(data, addons)
        .then((d) => {
          const tripId = d.data;
          console.log(tripId);
          database.updateUserGroups(userId, tripId, true);

          this.cities.forEach((cityResp) => {
            const city = cityResp;
            delete city.cityId;
            this.saveCity(tripId, city);
          });

          if (this.file) {
            const name = `${uuid.v4()}.${this.file.name.split(".").pop().toLowerCase()}`;
            const filePath = `groups/${tripId}/images/${name}`;
            storage.uploadFile(this.file, filePath).then(() => {
              firestore.updateTrip(tripId, {
                "files.header": filePath,
              });
              this.doneSaving(tripId);
            });
          } else {
            this.doneSaving(tripId);
          }
        })
        .catch((e) => {
          if (e.message === "insufficient-funds") {
            this.feedback = this.$t("NewTrip.insufficientFunds");
          } else {
            this.feedback = this.$t("errors.unknown");
          }

          this.saving = false;
        });
    },
    doneSaving(tripId) {
      console.log("done saving, starting trip:", tripId);
      this.saving = false;
      this.$router.push({ name: "Itinerary", params: { tripId } });
      Object.assign(this.$data, initialState());
    },

    onFilePicked(e) {
      const { files } = e.target;
      if (files[0] !== undefined) {
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          [this.file] = files;
          this.imageSrc = fr.result;
        });
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
  },
  computed: {
    addOnsPrice() {
      let price = 0;
      this.allAddOns.forEach((addOn) => {
        if (this.addOns.includes(addOn.id)) {
          price += addOn.price;
        }
      });
      return price;
    },
    companies() {
      const { companies } = this.$store.state;
      return Object.values(companies);
    },
    imageUrl() {
      return require("@/assets/trip.jpg");
    },
    promptAudioGuides() {
      let companyId = this.selectedCompanyId;
      if (this.companies.length > 1 && !companyId) {
        return false;
      }
      if (!companyId) {
        companyId = this.companies[0].id;
      }
      console.log("company id to select ", companyId);
      return companyId === "R1XBW59p2FFxo5WudH3H" || companyId === "I6Y9GSy3nJifTu0Eg6V7";
    },
  },
};
</script>
